import { render, staticRenderFns } from "./salesPromotion.vue?vue&type=template&id=ccd13b10&scoped=true"
import script from "./salesPromotion.vue?vue&type=script&lang=js"
export * from "./salesPromotion.vue?vue&type=script&lang=js"
import style0 from "./salesPromotion.vue?vue&type=style&index=0&id=ccd13b10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd13b10",
  null
  
)

export default component.exports